import { Component, OnInit, ViewEncapsulation, Input, Output, EventEmitter, AfterContentInit } from '@angular/core';
// import { debug } from 'util';
import { Router } from '@angular/router';
import { CommonService } from '../services/common.service';
import { TranslateService } from '@ngx-translate/core';
import { TransactionSourceDetails } from '../models/Transactions/DocumentApprovalEntity';
import { NgClass, NgStyle } from '@angular/common';
import { MatCard, MatCardHeader, MatCardTitle, MatCardSubtitle, MatCardContent } from '@angular/material/card';

@Component({
    selector: 'app-tile',
    templateUrl: './tile.component.html',
    styleUrls: ['./tile.component.scss'],
    encapsulation: ViewEncapsulation.None,
    imports: [NgClass, MatCard, MatCardHeader, MatCardTitle, MatCardSubtitle, MatCardContent, NgStyle]
})
export class TileComponent implements OnInit, AfterContentInit {
  @Input() dataInput: Array<TransactionSourceDetails>;
  @Output() navigateFunction: EventEmitter<any> = new EventEmitter();

  tileValues: any[];
  constructor(private router: Router, private _cs: CommonService, private _ts: TranslateService) { }

  ngOnInit() {
  }

  routeToModule(data: any) {
    if (data.RoutingUrl) {
      this.navigateFunction.emit(data);
    }
  }

  ngAfterContentInit() {
    this.tileValues = this.dataInput.map((source, i) => {
      if (source.SourceName === 'Requisition') {
        switch (source.TransactionsStatus) {
          case 'Approved':
            source.iconName = 'icon-requisition-approved';
            source.bgColor = '#aad969';
            break;
          case 'On Hold':
            source.iconName = 'icon-requisition-on-hold';
            source.bgColor = '#fd9200';
            break;
          case 'Pending':
            source.iconName = 'icon-Requisiton-Pending1';
            source.bgColor = '#FDD465';
            break;
          case 'Pending Submission':
            source.iconName = 'icon-Requisiton-Pending1';
            source.bgColor = '#fdb900';
            break;
          case 'Pending Approval':
            source.iconName = 'icon-Requisiton-Pending1';
            source.bgColor = '#fdb900';
            break;
          case 'Finalized':
            source.iconName = 'icon-requisition-finalized';
            source.bgColor = '#9e75fb';
            break;
          case 'Denied':
            source.iconName = 'icon-requisition-denied';
            source.bgColor = '#f75a2b';
            break;
          case 'Partial':
            source.iconName = 'icon-requisition-denied';
            source.bgColor = '#fd9200';
            break;
          case 'Total':
            source.iconName = 'icon-requisition';
            source.bgColor = '#C4ABFC';
            break;
            case 'Cancelled':
              source.iconName = 'icon-requisition';
              source.bgColor = '#6f1e51';
              break;
        }
        const title = 'tiles.' + source.SourceName;
        source.SourceName = this._ts.instant(title);
        const transactName = 'tiles.' + source.TransactionsStatus;
        source.TransactionsStatus = this._ts.instant(transactName);
      } else if (source.SourceName === 'Transfer') {

        switch (source.TransactionsStatus) {
          case 'Transfer':
            // source.iconName = 'icon-total-transfer';
            source.iconName = 'icon-transfer';
            source.bgColor = '#FDD465';
            break;
          case 'In Transit':
            source.iconName = 'icon-In_Transut_Single_path';
            source.bgColor = '#FDD465';
            break;
          case 'Transfers In':
            source.iconName = 'icon-transfer-in';
            source.bgColor = '#AAD969';
            break;
          case 'Total Transfers':
            source.iconName = 'icon-transfer';
            source.bgColor = '#FDD465';
            break;   
          case 'Transfer Out':
            source.iconName = 'icon-transfer-out';
            source.bgColor = '#FA9B7F';
            break;
          case 'Transfers':
            // source.iconName = 'icon-requisition-approved';
            // source.bgColor = '#AAD969';
            source.iconName = 'icon-transfer';
            source.bgColor = '#FDD465';
            break;
          case 'Requisition':
            // source.iconName = 'icon-requisition-on-hold';
            source.iconName = 'icon-requisition';
            source.bgColor = '#C4ABFC';
            break;
          case `PO's`:
            // source.iconName = 'icon-requisition-pending';
            source.iconName = 'icon-PO1';
            source.bgColor = '#FDBD65';
            break;
          case 'Spoilage':
            // source.iconName = 'icon-requisition-denied';
            source.iconName = 'icon-Spoilage';
            source.bgColor = '#FA9B7F';
            break;
          case 'RQA':
            source.iconName = 'icon-requested';
            source.bgColor = '#3383FF';
            break;
        }
        const title = 'tiles.' + source.SourceName;
        source.SourceName = this._ts.instant(title);
        const transactName = 'tiles.' + source.TransactionsStatus;
        source.TransactionsStatus = this._ts.instant(transactName);
      } else if (source.SourceName === 'InTransit' || source.SourceName === 'TransferAcknowledgement') {

        switch (source.TransactionsStatus) {
          case 'Transfer':
            source.iconName = 'icon-transfer';
            source.bgColor = '#FDD465';
            break;
          case 'In Transit':
            source.iconName = 'icon-In_Transut_Single_path';
            source.bgColor = '#FDD465';
            break;
          case 'Transfers In':
            source.iconName = 'icon-transfer-in';
            source.bgColor = '#AAD969';
            break;
          case 'Total Transfers':
            source.iconName = 'icon-transfer';
            source.bgColor = '#FDD465';
            break;   
          case 'Transfer Out':
            source.iconName = 'icon-transfer-out';
            source.bgColor = '#FA9B7F';
            break;
          case 'Transfers':
            source.iconName = 'icon-transfer';
            source.bgColor = '#FDD465';
            break;
          case 'Requisition':
            source.iconName = 'icon-requisition';
            source.bgColor = '#C4ABFC';
            break;
          case `PO's`:
            source.iconName = 'icon-PO1';
            source.bgColor = '#FDBD65';
            break;
          case 'Spoilage':
            source.iconName = 'icon-Spoilage';
            source.bgColor = '#FA9B7F';
            break;
          case 'RQA':
            source.iconName = 'icon-requested';
            source.bgColor = '#3383FF';
            break;
        }
        const title = 'tiles.' + source.SourceName;
        source.SourceName = this._ts.instant(title);
        const transactName = 'tiles.' + source.TransactionsStatus;
        source.TransactionsStatus = this._ts.instant(transactName);
      }
      if (source.SourceName === 'RQA') {
        switch (source.TransactionsStatus) {
          case 'Approved':
            source.iconName = 'icon-requisition-approved';
            source.bgColor = '#AAD969';
            break;
          case 'On Hold':
            source.iconName = 'icon-requisition-on-hold';
            source.bgColor = '#FDBD65';
            break;
          case 'Pending':
            source.iconName = 'icon-Requisiton-Pending1';
            source.bgColor = '#FDD465';
            break;
          case 'Finalized':
            source.iconName = 'icon-requisition-finalized';
            source.bgColor = '#C4ABFC';
            break;
          case 'Denied':
            source.iconName = 'icon-requisition-denied';
            source.bgColor = '#FA9B7F';
            break;
          case 'Total':
            source.iconName = 'icon-requisition-denied';
            source.bgColor = '#3383FF';
            break;
        }
        const title = 'tiles.' + source.SourceName;
        source.SourceName = this._ts.instant(title);
        const transactName = 'tiles.' + source.TransactionsStatus;
        source.TransactionsStatus = this._ts.instant(transactName);
      }
      if (source.SourceName === 'Licencing') {
        switch (source.TransactionsStatus) {
          case 'LICENSES':
            source.SourceName = 'Total';
            source.iconName = 'icon-requisition-approved';
            source.class = 'icon-tick-color';
            break;
          case 'UTILIZED':
            source.SourceName = 'Total';
            source.iconName = 'icon-seats-purchased';
            source.class = 'icon-color';
            break;
          case 'AVAILABLE':
            source.SourceName = 'Total';
            source.iconName = 'icon-requisition-finalized';
            source.class = 'icon-color';
            break;
        }
        const title = 'tiles.' + source.SourceName;
        source.SourceName = this._ts.instant(title);
        const transactName = 'tiles.' + source.TransactionsStatus;
        source.TransactionsStatus = this._ts.instant(transactName);
      }
      if (source.SourceName === 'Spoilage') {
        switch (source.TransactionsStatus) {
          case 'Total Spoilage':
            source.iconName = 'icon-requisition-approved';
            source.bgColor = '#aad969';
            break;
          case 'Approved Spoilage':
            source.iconName = 'icon-requisition-approved';
            source.bgColor = '#aad969';
            break;
          case 'OnHold Spoilage':
            source.iconName = 'icon-requisition-on-hold';
            source.bgColor = '#fd9200';
            break;
          case 'Denied Spoilage':
            source.iconName = 'icon-requisition-denied';
            source.bgColor = '#f75a2b';
            break;
          case 'Cancelled Spoilage':
            source.iconName = 'icon-cancel';
            source.bgColor = '#6f1e51';
            break;
          case 'Pending Approval':
            source.iconName = 'icon-Requisiton-Pending1';
            source.bgColor = '#FDD465';
            break;
        }
        const title = 'tiles.' + source.SourceName;
        source.SourceName = this._ts.instant(title);
        const transactName = 'tiles.' + source.TransactionsStatus;
        source.TransactionsStatus = this._ts.instant(transactName);
      }
      if (source.SourceName === 'Total') {
        switch (source.TransactionsStatus) {
          case 'Requisition':
            source.iconName = 'icon-requisition';
            source.bgColor = '#c4abfc';
            break;
          case 'Transfers':
            source.iconName = 'icon-transfer';
            source.bgColor = '#fdd465';
            break;
          case 'Pos':
            source.iconName = 'icon-PO1';
            source.bgColor = '#fdbd65';
            break;
          case 'Spoilage':
            source.iconName = 'icon-Spoilage';
            source.bgColor = '#fa9b7f';
            break;
        }
        const title = 'tiles.' + source.SourceName;
        source.SourceName = this._ts.instant(title);
        const transactName = 'tiles.' + source.TransactionsStatus;
        source.TransactionsStatus = this._ts.instant(transactName);
      }
      return source;
    });
  }

  getColor = (data) => {
    return data.bgColor;
  }
}

